import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/www/wwwroot/STARY-bc/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/STARY-bc/src/components/ProductList/ProductList.tsx");
